import Glide from "@glidejs/glide";

import "@glidejs/glide/src/assets/sass/glide.core.scss";
import "@glidejs/glide/src/assets/sass/glide.theme.scss";

onDomReady.then(() => {
  let slider = document.querySelector('.glide');
  if (slider) {
    new Glide('.glide', {}).mount();
  }
});